import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({

    fullHeight: {
        height: '10vh',
        textAlign: 'center',
        marginTop: '40vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-around'
    },
    loading: {
        height: '10vh',
        marginTop: theme.spacing(1),
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-around'
    }

}));

export const FingotiLoading = ({ fullHeight, text }) => {

    const classes = useStyles();

    if (fullHeight) {
        return (
            <div className={classes.fullHeight}>
                <CircularProgress style={{ marginBottom: '8px' }} />
                { text && 'Please give us a mo...' }
            </div>
        );
    } else {
        return (
            <div className={classes.loading}>
                <CircularProgress style={{ marginBottom: '8px' }} />
                { text && 'Please give us a mo...' }
            </div>
        );
    }
}

FingotiLoading.defaultProps = {
    fullHeight: true,
    text: true,
}

FingotiLoading.propTypes = {
    fullHeight: PropTypes.bool,
    text: PropTypes.bool,
}